import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import MenuItem from './menuItem'

function ChildMenu({ name, active_name, asideProducts, asideCars }) {
  let user_device = useSelector((state) => state?.deviceReducer?.device)

  return (
    <>
      {name === 'products' ? (
        <>
          <MenuItem name={name} active_name={name} />
          {asideProducts.map((product) => (
            <Link key={product.id} to={`products/${product.name}`}>
              {user_device === 'desktop' && (
                <div
                  className={
                    active_name === product.name
                      ? 'border-l-2 border-l-secondary rounded-r-md w-full p-2 my-3 pr-10 dark:text-amber-50'
                      : 'p-2 pr-10'
                  }
                >
                  <span
                    className={`text-md ${
                      active_name === product.name
                        ? 'text-main font-semibold dark:text-amber-50'
                        : 'text-inactive-link font-normal dark:text-slate-400 dark:hover:text-slate-300'
                    }`}
                  >
                    {product?.title}
                  </span>
                </div>
              )}
            </Link>
          ))}
        </>
      ) : (
        name === 'cars' && (
          <>
            <MenuItem name={name} active_name={name} />
            {asideCars.map((car) => (
              <Link key={car.id} to={`cars/${car.name}`}>
                {user_device === 'desktop' && (
                  <div
                    className={
                      active_name === car.name
                        ? 'border-l-2 border-l-secondary rounded-r-md w-full p-2 my-4 pr-10'
                        : 'mt-5 mb-0 p-2 pr-10'
                    }
                  >
                    <span
                      className={`text-md ${
                        active_name === car.name
                          ? 'text-main font-semibold dark:text-amber-50'
                          : 'text-inactive-link font-normal dark:text-slate-400 dark:hover:text-slate-300'
                      }`}
                    >
                      {car?.title}
                    </span>
                  </div>
                )}
              </Link>
            ))}
          </>
        )
      )}
    </>
  )
}

export default memo(ChildMenu)
